import React from 'react';
import { ConfigProvider, theme } from 'antd';
// import { useAuthStore } from '../store/auth'; // Moved to left nav
import { LeftNavigation } from './Navigation/LeftNavigation';
import { TabBar } from './Tabs/TabBar';
import { TabContent } from './Tabs/TabContent';
import { useTabStore } from '../store/tabs';
import { Workspace, SavedWorkspaceState } from '../types';
import { ErrorBoundary } from './ErrorBoundary';
import { apiService } from '../services/api';
import { NAMES } from '../data/names';

interface LayoutProps {}

export const Layout: React.FC<LayoutProps> = () => {
  // const { user } = useAuthStore(); // Removed as user info is now in left nav
  const { addTab, initializeDefaultTabs, tabs, setActiveTab } = useTabStore();
  const [isLeftNavOpen, setIsLeftNavOpen] = React.useState(true);

  // Initialize default tabs on mount
  React.useEffect(() => {
    initializeDefaultTabs();
  }, [initializeDefaultTabs]);

  // Environment info moved to TabBar component

  const handleWorkspaceSelect = async (workspace: Workspace) => {
    // Generate a random AI name for each new workspace instance
    const randomIndex = Math.floor(Math.random() * NAMES.length);
    const aiName = NAMES[randomIndex];
    
    const workspaceType = workspace.name;
    const tabData = {
      type: 'workspace' as const,
      title: `${aiName} (${workspaceType})`,
      workspace: {
        ...workspace,
        aiName // Update workspace object with random AI name
      },
    };
    
    addTab(tabData);
    
    // Don't close the navigation - keep it open for easier workspace switching
    // setIsLeftNavOpen(false);
  };

  const handleSavedStateRestore = async (workspace: Workspace, savedState: SavedWorkspaceState) => {
    try {
      const { restoreTabState } = useTabStore.getState();
      await restoreTabState(workspace, savedState.id);
      // Don't close the navigation - keep it open for easier workspace switching
      // setIsLeftNavOpen(false);
    } catch (error) {
      console.error('Failed to restore saved state:', error);
      // Could show error notification here
    }
  };

  const handleSettingsClick = () => {
    // Check if a settings tab is already open
    const existingSettingsTab = tabs.find(tab => tab.type === 'settings');
    
    if (existingSettingsTab) {
      // Switch to the existing settings tab
      setActiveTab(existingSettingsTab.id);
    } else {
      // Create a new settings tab
      addTab({
        type: 'settings',
        title: 'Settings',
      });
    }
    // Don't close the navigation - keep it open for easier access
    // setIsLeftNavOpen(false);
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
      }}
    >
      <div className="app-layout">
        <ErrorBoundary>
          <LeftNavigation
            isOpen={isLeftNavOpen}
            onClose={() => setIsLeftNavOpen(false)}
            onWorkspaceSelect={handleWorkspaceSelect}
            onSavedStateRestore={handleSavedStateRestore}
            onSettingsClick={handleSettingsClick}
          />
        </ErrorBoundary>

        <div style={{ 
          marginLeft: isLeftNavOpen ? '256px' : '0',
          transition: 'margin-left 0.11s cubic-bezier(0.2, 0, 1, 0.9)',
          height: '100vh', // Full height since no header
          width: isLeftNavOpen ? 'calc(100% - 256px)' : '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <ErrorBoundary>
            <TabBar />
          </ErrorBoundary>
          <div style={{ flex: 1, overflow: 'hidden', width: '100%' }}>
            <ErrorBoundary>
              <TabContent />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};